import * as React from 'react';
import { createFileRoute, redirect, useRouteContext } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PageTitleContext } from '../__root';
import { AdminLandingCards } from '../../features/admin/components/admin-landing';
import { SYSTEM_ROLE_CODE } from '../../features/permissions/lib/role-codes';

// ─── Route ───────────────────────────────────────────────────

export const Route = createFileRoute('/admin/')({
  beforeLoad: ({ context }) => {
    const user = context.auth.user;
    if (!user || !user.roles.includes(SYSTEM_ROLE_CODE)) {
      throw redirect({ to: '/media-units' });
    }
  },
  component: AdminIndexRoute,
});

function AdminIndexRoute() {
  useRouteContext({ from: '__root__' });
  return <AdminLandingPage />;
}

// ─── Page (exported for testing) ─────────────────────────────

export function AdminLandingPage() {
  const { setPageTitle } = React.useContext(PageTitleContext);
  const { t } = useTranslation('common');

  React.useEffect(() => {
    setPageTitle(t('adminLanding.heading'));
  }, [setPageTitle, t]);

  return <AdminLandingCards />;
}
